import { useState } from 'react'
import {
  ArrowBackIcon,
  CheckCircleIcon,
  ViewIcon,
  ViewOffIcon
} from '@chakra-ui/icons'
import {
  Box,
  Button,
  Flex,
  FormControl,
  Heading,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  List,
  ListIcon,
  ListItem,
  Stack,
  Text,
  useMediaQuery,
  VStack
} from '@chakra-ui/react'
import { Link, useNavigate } from 'react-router-dom'

import SessionStartLogo from '../../components/SessionStartLogo'
import {
  validateKeyUpPassword,
  validateAccount
} from '../../utils/functionsValidateRegister'
import clientAxios from '../../config/axios'

const quilmesImages = require.context('../../assets/images', true)

const CreateAccount = () => {
  /* Hide password */
  const [show, setShow] = useState(false)
  const [checks, setChecks] = useState({
    lowercase: false,
    uppercase: false,
    length: false,
    number: false,
    space: false
  })
  const [errorName, setErrorName] = useState('')
  const [errorEmail, setErrorEmail] = useState('')
  const [errorPassword, setErrorPassword] = useState('')
  const [errorSurname, setErrorSurname] = useState('')
  const [register, setRegister] = useState({
    name: '',
    surname: '',
    mail: '',
    password: ''
  })
  const navigate = useNavigate()
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')

  const handleClick = () => setShow(!show)

  const handleChange = (e) => {
    const { name, value } = e.target

    setRegister({ ...register, [name]: value })
  }

  const handleOnKeyUpPassword = (e) => {
    const { value } = e.target

    if (
      checks.lowercase ||
      checks.uppercase ||
      checks.length ||
      checks.number || checks.space
    ) {
      setErrorPassword('')
    }

    setChecks(validateKeyUpPassword(value))
  }

  const handleOnBlurPassword = () => {
    if (register.password === '') {
      setErrorPassword('')

      return
    }
    if (
      !checks.lowercase ||
      !checks.uppercase ||
      !checks.length ||
      !checks.number
    ) {
      setErrorPassword('La contraseña no cumple con los requisitos.')
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const error = validateAccount(register)

    if (error.name) {
      setErrorName(error.name)
    }

    if (error.mail) {
      setErrorEmail(error.mail)
    }

    if (error.password) {
      setErrorPassword(error.password)
    }

    if (error.surname) {
      setErrorSurname(error.surname)
    }
    if (error.name || error.mail || error.password || error.surname) {
      return
    }

    clientAxios.post('/auth/signup', register).then((res) => {
      sessionStorage.setItem('mail', JSON.stringify(register.mail))
      navigate('/register-success')
    })
      .catch((error) => {
        if (error.response.data.message === 'EMAIL_EXISTS') {
          setErrorEmail('Este correo electrónico ya esta registrado.')
        }
      })
  }

  const handleFocusError = () => {
    const error = validateAccount(register)

    if (error.name || error.mail || error.password || error.surname) {
      setErrorName('')
      setErrorEmail('')
      setErrorPassword('')
      setErrorSurname('')
    }
  }

  return (
    <Box display={{ md: 'flex' }} justifyContent={'center'}>
      <Box className='account-container' mx={'auto'}>
        <VStack
          alignItems={'flex-start'}
          as='form'
          autoComplete='off'
          padding={{ base: '2rem 1rem 2rem 1rem', md: '3rem 1rem 2rem 1rem' }}
          w={{ base: '100%', md: '100%' }}
          onSubmit={handleSubmit}

        >
          <SessionStartLogo />
          <Link to={'/'}>
            <ArrowBackIcon
              color={'#0A0808'}
              h={6}
              marginTop={{ base: 6, md: 4 }}
              w={6}
            />
          </Link>
          <Heading fontSize={'1.5rem'} fontWeight={'400'} paddingTop={'1rem'}>
            Crear Cuenta
          </Heading>
          <Text fontSize={'1rem'} fontWeight={'400'}>
            Por favor ingrese los siguientes datos.
          </Text>

          <Stack paddingTop={'1rem'} w={{ base: '100%', md: 400 }}>
            <FormControl
              className='floating-label-group'
              paddingBottom={{ base: 4, md: 1 }}
              onFocus={handleFocusError}
            >
              <Input
                autoComplete='new-text'
                className='input'
                id='name'
                name='name'
                placeholder=' '
                type='text'
                value={register.name}
                onChange={handleChange}
                onFocus={handleFocusError}
                {...(errorName !== ''
                  ? { borderColor: 'red.500' }
                  : {})}
                _hover={{ ...(errorName !== '' ? { borderColor: 'red.500' } : {}) }}
              />
              <label className='placeholder' htmlFor='name'>
                Nombre *
              </label>
              {errorName && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'.5rem'}
                  w={{ base: '75%', md: 400 }}
                >
                  {errorName}
                </Text>
              )}
            </FormControl>

            <FormControl
              className='floating-label-group'
              paddingBottom={{ base: 4, md: 1 }}
            >
              <Input
                autoComplete='new-text'
                className='input'
                id='surname'
                name='surname'
                placeholder=' '
                type='text'
                value={register.surname}
                onChange={handleChange}
                onFocus={handleFocusError}
                {...(errorSurname !== ''
                  ? { borderColor: 'red.500' }
                  : {})}
                _hover={{ ...(errorSurname !== '' ? { borderColor: 'red.500' } : {}) }}
              />
              <label className='placeholder' htmlFor='surname'>
                Apellido *
              </label>
              {errorSurname && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'.5rem'}
                  w={{ base: '75%', md: 400 }}
                >
                  {errorSurname}
                </Text>
              )}
            </FormControl>

            <FormControl
              className='floating-label-group'
              paddingBottom={{ base: 4, md: 1 }}
            >
              <Input
                autoComplete='new-text'
                className='input'
                id='mail'
                name='mail'
                placeholder=' '
                type='text'
                value={register.mail}
                onChange={handleChange}
                onFocus={handleFocusError}
                {...(errorEmail !== ''
                  ? { borderColor: 'red.500' }
                  : {})}
                _hover={{ ...(errorEmail !== '' ? { borderColor: 'red.500' } : {}) }}
              />
              <label
                className='placeholder'
                htmlFor='mail'
                {...(errorEmail !== '' ? { className: 'error-input' } : {})}
              >
                Correo electrónico *
              </label>

              {errorEmail && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'.5rem'}
                  w={{ base: '75%', md: 400 }}
                >
                  {errorEmail}
                </Text>
              )}
            </FormControl>

            <FormControl
              className='floating-label-group'
              paddingBottom={{ base: 4, md: 1 }}
            >
              <InputGroup>
                <Input
                  autoComplete='new-password'
                  className='input'
                  id='password'
                  name='password'
                  placeholder=' '
                  type={show ? 'text' : 'password'}
                  value={register.password}
                  onBlur={handleOnBlurPassword}
                  onChange={handleChange}
                  onFocus={handleFocusError}
                  onKeyUp={handleOnKeyUpPassword}
                  {...(errorPassword !== ''
                    ? { borderColor: 'red.500' }
                    : {})}
                  _hover={{ ...(errorPassword !== '' ? { borderColor: 'red.500' } : {}) }}
                />
                <label
                  className='placeholder'
                  htmlFor='password'
                  {...(errorPassword !== ''
                    ? { className: 'error-input' }
                    : {})}
                >
                  Contraseña *
                </label>
                <InputRightElement width='4.5rem'>
                  <Button
                    _active={{ background: 'none' }}
                    _focusVisible={{ boxShadow: 'none' }}
                    _hover={{ background: 'none' }}
                    arial-label='Mostrar contraseña'
                    background={'none'}
                    marginLeft={'1.5rem'}
                    onClick={handleClick}
                  >
                    {show
                      ? (
                        <ViewIcon color='#DB580B' />
                      )
                      : (
                        <ViewOffIcon color='blackAlpha.500' />
                      )}
                  </Button>
                </InputRightElement>
              </InputGroup>
              {errorPassword && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'.5rem'}
                  w={{ base: '75%', md: 400 }}
                >
                  {errorPassword}
                </Text>
              )}
            </FormControl>
          </Stack>

          <Box
            alignItems={'flex-start'}
            padding={'1rem 0rem 0rem 0rem'}
            w={{ base: '100%', md: 400 }}
          >
            <Text fontSize={'14px'} fontWeight={'700'}>
              La contraseña debe tener:
            </Text>

            <List padding={'1rem 0rem 0rem 0rem'} spacing={2}>
              <ListItem display={'flex'}>
                <ListIcon h={'1.4rem'} w={'1.4rem'}>
                  <CheckCircleIcon
                    {...(checks.length
                      ? { color: '#69AE00' }
                      : errorPassword
                        ? { color: 'red' }
                        : { color: '#E1E1E1' })}
                  />
                </ListIcon>
                <Text fontSize={'14px'} fontWeight={'400'}>
                  Entre 8 y 20 caracteres.
                </Text>
              </ListItem>
              <ListItem display={'flex'}>
                <ListIcon h={'1.4rem'} w={'1.4rem'}>
                  <CheckCircleIcon
                    {...(checks.lowercase
                      ? { color: '#69AE00' }
                      : errorPassword
                        ? { color: 'red' }
                        : { color: '#E1E1E1' })}
                  />
                </ListIcon>
                <Text fontSize={'14px'} fontWeight={'400'}>
                  Una minúscula.
                </Text>
              </ListItem>
              <ListItem display={'flex'}>
                <ListIcon h={'1.4rem'} w={'1.4rem'}>
                  <CheckCircleIcon
                    {...(checks.uppercase
                      ? { color: '#69AE00' }
                      : errorPassword
                        ? { color: 'red' }
                        : { color: '#E1E1E1' })}
                  />
                </ListIcon>
                <Text fontSize={'14px'} fontWeight={'400'}>
                  Una mayúscula.
                </Text>
              </ListItem>
              <ListItem display={'flex'}>
                <ListIcon h={'1.4rem'} w={'1.4rem'}>
                  <CheckCircleIcon
                    {...(checks.number
                      ? { color: '#69AE00' }
                      : errorPassword
                        ? { color: 'red' }
                        : { color: '#E1E1E1' })}
                  />
                </ListIcon>
                <Text fontSize={'14px'} fontWeight={'400'}>
                  Un número.
                </Text>
              </ListItem>
            </List>
          </Box>

          <Stack justifyContent='center' w={{ base: '100%', md: 400 }}>
            <Button
              _focusVisible={{ outline: 'none' }}
              marginTop={'2rem'}
              type='submit'
              variant={'btn-quilmes'}
            >
              Crear Cuenta
            </Button>
          </Stack>
        </VStack>
        {/* <Box textAlign={'center'}>
          <Text
            color={'#0A0808'}
            fontSize={'14px'}
          >Iniciar sesión con Google o Microsoft</Text>
          <Flex gap={4} justifyContent={'center'}>
            <Button
              _active={{ background: 'none' }}
              _hover={{ background: 'none' }}
              bg={'#FFF'}
              borderRadius={'50%'}
              h={'3rem'}
              marginTop={4}
              padding={0}
              w={'3rem'}
              onClick={handleGoogleSignin}
            >
              <Image
                alt='Google'
                objectFit={'cover'}
                src={quilmesImages('./google.svg')}
              />
            </Button>
            <Button
              _active={{ background: 'none' }}
              _hover={{ background: 'none' }}
              bg={'#FFF'}
              borderRadius={'50%'}
              h={'3rem'}
              marginTop={4}
              padding={0}
              w={'3rem'}
            >
              <Image
                alt='Microsoft'
                height={'3rem'}
                src={quilmesImages('./microsoft.svg')}
                width={'3rem'}
              />
            </Button>
          </Flex>
        </Box> */}
      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default CreateAccount
